var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('router-view',{on:{"loggedin":_vm.loadUser,"login":_vm.clean}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }